export const initialState = {
    showChatMessageWindow: true,
    showMainChatWindow: false,
    mainChatWindowExpanded: true,
    waitingReply: false,
    chatMessages: [],
    userMessage: '',
    chatHistory: [],
    showChatHistory: true,
    showSearchHistory: false,
    chatHistoryOffset: 0,
    chatHistoryLimit: 30,
    chatMesageOffset: 0,
    chatMessageLimit: 20,
    loading: false,
    docName: '',
    docId: '',
    itemId: '', //slected language
    //userId: '',
    chatId: '',
    resId: '', //collection id allowing viewonline
    pubId: '',
    //subId: '',
    
    noChatHistroy: false,
    versions: [], //available versions
    faqFetched: false, //faq fetched
    faqs: [],  //faq options
    versionId: '', //selected version id
    versionName: '', //selected version name
    faq: '',  //selected faq
    
    wizardStep: 'version-selection',
    showVersionOptions: false,

    quotaUsed: 0,
    quotaAvailable: 0,
    searchTerm: '',
    searchResult: [],
    noSearchResult: false,
    ajaxAbortController: {},

    loadChatMsgsProcessing:false,
    loadMoreMsgsProcessing: false,
    loadMoreChatProcessing: false,
    searchChatHistoryProcessing: false,
    loadFaqProcessing: false,
    loadChatHistoryProcessing: false,
    showConfirmDeleteModal: false,
    selectedChatItemForDelete: false
};
export default () => (JSON.parse(JSON.stringify(initialState))); // Deep clone the initial state to avoid reference issues